import { showError, showErrorAxios } from "infra/helpers/alerta";
import excelToJson from "infra/helpers/excelToJson";
import { useState } from "react";
import { AxiosError } from "axios";

type ErrorType = {
  successIndexes: number[];
  message: string;
  errors: { field: string; message: string[]; index: number }[];
};

export function useImportarPlanilha<T>() {
  const [data, setData] = useState<T[]>([]);

  function onRowDelete(
    _: React.MouseEvent<HTMLDivElement>,
    { rowIdx }: { rowIdx: number }
  ) {
    setData([...data.slice(0, rowIdx), ...data.slice(rowIdx + 1)]);
  }

  function onRowInsertAbove(
    _: React.MouseEvent<HTMLDivElement>,
    { rowIdx }: { rowIdx: number }
  ) {
    insertRow(rowIdx);
  }

  function onRowInsertBelow(
    _: React.MouseEvent<HTMLDivElement>,
    { rowIdx }: { rowIdx: number }
  ) {
    insertRow(rowIdx + 1);
  }

  function insertRow(insertRowIdx: number) {
    const newRow: T = {} as T;

    setData([
      ...data.slice(0, insertRowIdx),
      newRow,
      ...data.slice(insertRowIdx),
    ]);
  }

  const proccessFile = async (file: File) => {
    try {
      const rows = await excelToJson<T & { index: any }, keyof T>(file);
      setData(rows);
    } catch (err) {
      showError("Planilha em formato incorreto!");
    }
  };

  const onRequestError = async (err: AxiosError) => {
    if (err.response?.status === 422) {
      let _err = err.response.data as ErrorType;

      const newData = data.map((item, index) => {
        const errors: any = _err.errors
          .filter((err) => err.index === index)
          .reduce((acc, next) => {
            if (acc[next.field]) {
              acc[next.field] = acc[next.field].concat(next.message);
            } else {
              acc[next.field] = next.message;
            }
            return acc;
          }, {} as Record<string, string[]>);

        return {
          ...item,
          errors,
        };
      });

      showError(_err.message).then(() => {
        setData([...newData]);
      });
    } else {
      showErrorAxios(err);
    }
  };

  return {
    proccessFile,
    onRequestError,
    onRowInsertBelow,
    onRowInsertAbove,
    onRowDelete,
    setData,
    data,
  };
}
